import blue from './blue'
import green from './green'
import orange from './orange'
import pink from './pink'
import purple from './purple'
import yellow from './yellow'

export default [blue, green, orange,pink, purple, yellow ]